import { ExamList } from "./exam-list";
export class ExtraDataRow {
    constructor(data) {
        this.enumValues = [];
        this._deleted = false;
        this.html = {};
        this.children = [];
        this.description = "";
        this.order = 0;
        this.exams = new ExamList();
        this.createHtml();
        if (data) {
            this.id = data.id;
            this.name = data.name;
            this.required = data.required;
            this.enumValues = data.enumValues;
            this.description = data.description;
            this.valueParent = data.valueParent;
            this.order = data.order;
            this.exams.addAll(data.exams || []);
            this._deleted = data.deleted;
        }
    }
    get childrenWrapper() {
        return this.html.children;
    }
    setParent(parent, value) {
        if (value !== undefined) {
            this.valueParent = value;
        }
        if (parent) {
            parent.children.push(this);
        }
        else {
            delete this.children[this.children.indexOf(this)];
        }
        this.parent = parent;
    }
    get typeName() {
        let typeName = this.type.name;
        if (this.enumValues !== undefined && this.enumValues.length > 0) {
            typeName += ` (${this.enumValues.join(", ")})`;
        }
        return typeName;
    }
    get requiredText() {
        return this.required ? yesMessage : noMessage;
    }
    get parentRestrictionText() {
        if (!this.parent) {
            return alwaysMessage;
        }
        let message = onlyWhen;
        const valueParentName = this.valueParent;
        if (this.parent.enumValues.length == 0) {
            message = valueParentName == "1" ? onlyChecked : onlyUnchecked;
        }
        return message
            .replace("{fieldName}", this.parent.name)
            .replace("{value}", valueParentName);
    }
    updateHtml() {
        const parent = "";
        this.html.name.html(this.name);
        this.html.type.html(this.typeName);
        this.html.required.html(this.requiredText);
        this.html.description.html(this.description);
        this.html.parent.html(this.parentRestrictionText);
        if (this.deleted) {
            this.html.wrapper.addClass("deleted");
        }
        else {
            this.html.wrapper.removeClass("deleted");
        }
        this.html.exams.html(this.exams.getNameCommaSeparated());
    }
    get deleted() {
        return this._deleted;
    }
    attachWrapper(previous) {
        if (previous instanceof ExtraDataRow) {
            previous.html.wrapper.after(this.html.wrapper);
        }
        else {
            this.html.wrapper.prependTo($(previous));
        }
    }
    createHtml() {
        this.html.wrapper = $("#fieldTemplate")
            .clone()
            .data("row", this)
            .removeClass("hidden");
        const text = this.html.wrapper.find(".text");
        this.html.name = text.find(".name .value");
        this.html.type = text.find(".type .value");
        this.html.required = text.find(".required-field .value");
        this.html.exams = text.find(".exams .value");
        this.html.description = text.find(".description .value");
        this.html.parent = text.find(".parent .value");
        this.addEventsToButtons(this.html.wrapper.find(".buttons"));
        this.html.children = this.html.wrapper.find(".children").sortable({
            stop: () => ExtraDataRow.onReorder(this),
        });
    }
    onDelete(confirmed) {
        if (confirmed || this.children.length === 0) {
            this._deleted = true;
        }
        this.updateHtml();
    }
    addEventsToButtons(buttons) {
        buttons.find(".added").on("click", () => ExtraDataRow.onEdit(this));
        buttons.find(".delete").on("click", () => this.onDelete(true));
        buttons.find(".recover").on("click", () => {
            this.html.wrapper.removeClass("deleted");
            this._deleted = false;
        });
    }
    get firstChildOrder() {
        return this.order * 100 + 1;
    }
    get dataForAjax() {
        const children = [];
        for (const child of this.children) {
            children.push(child.dataForAjax);
        }
        return {
            id: !this.id ? null : this.id,
            name: this.name,
            description: this.description,
            enum_values: this.enumValues,
            deleted: this.deleted,
            order: this.order,
            required: this.required,
            type: this.type.id,
            parentValue: this.valueParent === undefined ? "" : this.valueParent,
            children,
            exams: this.exams.getIdsArray(),
        };
    }
}
